import { ifAuthenticated, mustBeAdmin } from "../util/auth";

const Wallet = () => import("../components/content/wallets/wallet");
const WalletPage = () => import("../components/content/wallets/walletPage");

export const walletRoutes = {
  path: "/wallet",
  component: Wallet,
  children: [
    {
      path: "",
      component: WalletPage
    }
  ],
  // beforeEnter: ifAuthenticated
  beforeEnter: mustBeAdmin
};
